<template>
    <BasicLayout :left='left' :middle='middle' :right='right'>
        <template v-slot:right_view>
            <CustomDialog ref='activedialog' :element='devDialog.element' :styles='devDialog.styles' >
                <template v-slot:dialog-content>
                    <active-task ref="acttask" @close='cancel'></active-task>
                </template>
            </CustomDialog>
            <div class='h-outTabs'>
                <ejs-tab ref='verQueryTab' >
                    <e-tabitems>
                        <e-tabitem :header='tab[0]' content='#store'></e-tabitem>
                        <e-tabitem :header='tab[1]' content='#run'></e-tabitem>
                    </e-tabitems>
                </ejs-tab>
                <div id='store'>
                    <div class='h-toolbarBg'>
                        <div class='h-inputBox' style="margin-left:25px">
                            <ejs-textbox  :placeholder='$t("System.inputTip7")' @keydown.enter.native="storeSearch" v-model='storeinput' />
                        </div>
                    </div>
                    <ejs-grid :dataSource='storedata' ref='storegrid' height='calc(100vh - 276px)' :allowResizing='true' :pageSettings='pageSettings' allowPaging='true'>
                        <e-columns>
                            <!-- <e-column type='checkbox' width='18'></e-column> -->
                            <e-column field='neName' :headerText='$t("Software.td_neID")' width='6%' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='neType' :headerText='$t("Software.td_neName")' width='6%' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='pkgVer' :headerText='$t("Software.td_packageVer")' width='8%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='mainPkgVer' :headerText='$t("Software.td_mainPkgVer")' width='8%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='isSupportMS' :headerText='$t("Software.td_isSupportMS")' width='5%' :valueAccessor='binaryFormatter' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='isSupportRbk' :headerText='$t("Software.td_isSupportRbk")' width='5%' :valueAccessor='binaryFormatter' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='pkgStatus' :headerText='$t("Software.td_pkgStatus")' width='4%' :valueAccessor='pkgStatusFormatter' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='detail' :headerText='$t("Software.query_remarks")' width='8%' clipMode='EllipsisWithTooltip'></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div id='run' style='display: none;'>
                    <div class='h-toolbarBg'>
                        <div class='h-inputBox' style="margin-left:25px">
                            <ejs-textbox  :placeholder='$t("System.inputTip7")' @keydown.enter.native="runSearch" v-model='runinput' />
                        </div>
                    </div>
                    <ejs-grid :dataSource='rundata' ref='rungrid' height='calc(100vh - 276px)' :allowResizing='true' :pageSettings='pageSettings' allowPaging='true'>
                        <e-columns>
                            <e-column field='neName' :headerText='$t("Software.td_neID")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='neType' :headerText='$t("Software.td_neName")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                            <e-column field='cabinetId' :headerText='$t("Software.query_cabinetId")' width='15%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='frameId' :headerText='$t("Software.query_frameId")' width='15%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='slotId' :headerText='$t("Software.query_slotId")' width='10%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='appVersion' :headerText='$t("Software.query_appVersion")' width='15%' clipMode='EllipsisWithTooltip' :valueAccessor='typeFormat'></e-column>
                            <e-column field='detail' :headerText='$t("Software.query_remarks")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </div>
        </template>
    </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import CustomDialog from '../../components/common/CustomDialog';
import ActiveTask from '../../components/software/ActiveTask';
import { isNullOrUndefined } from "@syncfusion/ej2-base";
import {stringify} from 'qs';
import { Resize, Page } from "@syncfusion/ej2-vue-grids";
let storeSource = [];
let runSource = [];
export default {
    components: {
        BasicLayout,
        CustomDialog,
        ActiveTask
    },
    data() {
        return{
            left: { show: false, name: '' },
            middle: { show: false, name: '' },
            right: { show: true, crumb: this.$t('Software.que_version')},
            devDialog: {
                element: {
                    target: '#app',
                    isClose: true,
                    title: '版本查询',
                    refName: '激活',
                    buttonGroup: [
                        { click: this.submit, buttonModel: { content: 'Submit', isPrimary: true } },
                        { click: this.cancel, buttonModel: { content: 'Cancel' } }
                    ]
                },
                styles: {
                    width: '600px',
                    height: '310px',
                    visible: false,
                    model: true
                },
            },
            tab: [
                { text: `${this.$t('Software.storeversion')}` },
                { text: `${this.$t('Software.runversion')}` }
            ],
            data: [],
            finish: {
                store: false,
                run: false
            },
            pageSettings: { pageSizes: false, pageCount: 4, pageSize: 15 },
            nedata: [],
            storedata: [],
            rundata: [],
            storeinput: '',
            runinput: '',
            disabled: false,
            history: false,
            binarymap: new Map(
                [
                    [1,this.$t('Software.vmyes')],
                    [0,this.$t('Software.vmno')],
                ]),
            pkgstamap: new Map(
                [
                    [0,this.$t('Software.reserved')],
                    [1,this.$t('Software.running')], 
                    [2,this.$t('Software.active')], 
                ])
        }
    },
    provide: {
      grid: [Resize,Page]
    },
    mounted() {
        this.getNetree();
    },
    methods: {
        getNetree() {
            let para = {
                systemId: '1'
            }
            this.$loading.showLoadding(this.$t('Software.queVersion'),this.$t('SubscriberIms.waitTip'));
            //储存版本查询
            this.axios.get('/lte/ems/verquery_new/queryEnodebVersion',{
            }).then( response => {
                if(response.data.errorCode == 'SUCCESS')
                {
                    storeSource = response.data.resultVal;
                    this.storedata = storeSource;
                }
                this.queryCallBack(0);
            });
            //运行版本查询
            this.axios.get('/lte/ems/verquery_new/queryVerAction',{
            }).then( response => {
                if(response.data.errorCode == 'SUCCESS')
                {
                    runSource = response.data.resultVal;
                    this.rundata = runSource;
                }
                this.queryCallBack(1);
            });
        },

        queryCallBack(args)
        {
            if(args === 0)
            {
                this.finish.store = true;
            }
            else
            {
                this.finish.run = true;
            }
            if(this.finish.store && this.finish.run)
            {
                this.$loading.hideLoadding();
            }
        },
        binaryFormatter(field, data, column) {
            if(data[field] === null || data[field]==='')
            {
                return  '---';
            }
            return this.binarymap.get(data[field]);
        },

        typeFormat(field, data, column) {
            if(data[field] === null || data[field]==='')
            {
                return  '---';
            }
            return data[field];
        },
        pkgStatusFormatter(field, data, column) {
            if(data[field] === null || data[field]==='')
            {
                return  '---';
            }
             return this.pkgstamap.get(data[field]);
        },
        storeSearch(args) {
            if(this.storeinput === '') {
                this.storedata = storeSource;
            }
            else
            {
                const colmap = new Map([
                    ['isSupportMS', this.binarymap],
                    ['isSupportRbk', this.binarymap],
                    ['pkgStatus', this.pkgstamap],
                ])
                this.storedata = this.search(this.storeinput,storeSource,this.$refs.storegrid.getColumns(),colmap)
            }
        },
        runSearch(args) {
            if(this.runinput === '') {
                this.rundata = runSource;
            }
            else{
                this.rundata = this.search(this.runinput,runSource,this.$refs.rungrid.getColumns())
            }
        },
        search(input,source,columns,maparray) {
            var filterdata = source.filter( item => {
                let columntext = Array.from(columns, x => {
                    return x.field;
                });
                let feildData = Array.from(columntext, x => {
                    if(maparray && maparray.has(x)){
                        let value = maparray.get(x).get(item[x]);
                        return isNullOrUndefined(value) ? '' : value;
                    }
                    else{
                        return isNullOrUndefined(item[x]) ? '' : item[x] +'';
                    }
                });
                let filres = false;
                feildData.forEach(item => {
                    if(item.indexOf(input) > -1)
                    {
                        filres = true;
                    }
                });
                return filres;
            }).map( item => { return item });
            return filterdata;
        },
        click() {
            const taskObjs = this.getSelect();
            console.log("taskObjs",taskObjs)
            if(taskObjs.length === 0)
            {
                return;
            }
            let iseff = true;
            taskObjs.forEach(item => {
                if(item.pkgStatus !== 0) {
                    iseff = false;

                }
            })
            if(!iseff) {
                this.$parent.showToast('warning',`${this.$t("Software.onlyReserveAllowed")}`);
                return;
            }
            else {
                this.$refs.activedialog.show();
            }
        },
        getSelect() {
            return this.$refs.storegrid.getSelectedRecords();
        },
        submit() {
            const taskObjs = this.getSelect();
            this.$refs.acttask.active(taskObjs, () => {
                this.cancel();
                this.$router.push({ path:'/software/versionUpdate' })
            });
        },
        cancel() {
            this.$refs.activedialog.close();
        },
    }
}
</script>>